import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormattedNumberInput } from '@rd-web-markets/shared/dist/util';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
const ElsterAssetCalculation = _ref => {
  let {
    calculationResult,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3 mt-4"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h5", {
    style: {
      height: '100px',
      display: 'flex',
      alignItems: 'center'
    }
  }, t('calculations'), loading && /*#__PURE__*/React.createElement("span", {
    className: "ms-2",
    style: {
      height: '100px',
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  }))))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('b1_difference_acquisition_production')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.b1_difference_acquisition_production,
    name: "b1_difference_acquisition_production",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "b1_difference_acquisition_production-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('b2_less_pro_rata_conditions_inclusion')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.b2_less_pro_rata_conditions_inclusion,
    name: "b2_less_pro_rata_conditions_inclusion",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "b2_less_pro_rata_conditions_inclusion-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('b3_less_expenses_other_funding')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.b3_less_expenses_other_funding,
    name: "b3_less_expenses_other_funding",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "b3_less_expenses_other_funding-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('b4_difference_acquisition_production_costs_value_end_fiscal_year')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.b4_difference_acquisition_production_costs_value_end_fiscal_year,
    name: "b4_difference_acquisition_production_costs_value_end_fiscal_year",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "b4_difference_acquisition_production_costs_value_end_fiscal_year-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('c1_difference_value_end_previous_fiscal_year')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.c1_difference_value_end_previous_fiscal_year,
    name: "c1_difference_value_end_previous_fiscal_year",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "c1_difference_value_end_previous_fiscal_year-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('c2_less_prorated_conditions_inclusion_exclusive_use')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.c2_less_prorated_conditions_inclusion_exclusive_use,
    name: "c2_less_prorated_conditions_inclusion_exclusive_use",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "c2_less_prorated_conditions_inclusion_exclusive_use-test-id"
  }))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('c3_less_expenses_other_funding_claimed')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.c3_less_expenses_other_funding_claimed,
    name: "c3_less_expenses_other_funding_claimed",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "c3_less_expenses_other_funding_claimed-test-id"
  })), /*#__PURE__*/React.createElement(Form.Group, {
    as: Col
  }, /*#__PURE__*/React.createElement(Form.Label, null, t('c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year')), /*#__PURE__*/React.createElement(FormattedNumberInput, {
    thousandSeparator: ".",
    decimalSeparator: ",",
    value: calculationResult === null || calculationResult === void 0 ? void 0 : calculationResult.c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year,
    name: "c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year",
    type: "text",
    size: "sm",
    disabled: true,
    "data-testid": "c4_difference_value_end_previous_fiscal_year_value_end_fiscal_year-test-id"
  }))));
};
export default ElsterAssetCalculation;